import {
  deleteUserCart,
  updateUserCart,
  saveUserCart
} from "@/collections/userCart";

let cart = window.localStorage.getItem("cart");
let admincart = window.localStorage.getItem("admincart");
let stripeCheckoutItems = window.localStorage.getItem("stripeCheckoutItems");
let menuGroupItem = window.localStorage.getItem("menuGroupItem");

const state = {
  cart: cart ? JSON.parse(cart) : [],
  admincart: admincart ? JSON.parse(admincart) : [],
  loading: false,
  cubataItem: null,
  productTypeIds: {
    drinks: process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID,
    food: process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID,
    dessert: process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID
  },
  stripeCheckoutItems: stripeCheckoutItems
    ? JSON.parse(stripeCheckoutItems)
    : [],
  menuGroupItem: menuGroupItem ? JSON.parse(menuGroupItem) : [],
  qrExpiryTime: null,
  language: "es"
};

const mutations = {
  setLanguage(state, payload) {
    state.language = payload;
  },
  async addToCart(state, payload) {
    try {
      let menuGroupItem = payload.item.isMenuGroupProduct
        ? "menu_group_item"
        : "cart_item";
      let product = getProductFromCart(menuGroupItem, state, payload, true);

      if (product) {
        console.log("productAddToCart", product);
        let productId = product.id ? product.id : product.product_id;
        if (product.weight === undefined || product.weight === null) {
          product.quantity++;
        }
        payload.update && (await updateUserCart(productId, product));
      } else {
        state.loading = true;
        setTimeout(() => {
          state.loading = false;
        }, 1500);

        if (isAdminCart(payload.item)) {
          state.admincart.push(payload.item);
        } else {
          state.cart.push(payload.item);
        }
      }

      this.commit("saveData", payload);
    } catch (error) {
      this.setlogError(
        "update_user_cart",
        "Obtained error message in addToCart()",
        error.stack,
        this.$options.name
      );
    }
  },
  removeAllCart(state) {
    state.cart = [];
    this.commit("saveData");
  },
  removeAllAdminCart(state) {
    state.admincart = [];
    this.commit("saveData");
  },
  async removeFromCart(state, item) {
    try {
      if (isAdminCart(item)) {
        let index = state.admincart.indexOf(item);
        let productId = state.admincart[index].id
          ? state.admincart[index].id
          : state.admincart[index].product_id;

        if (state.admincart[index].quantity > 1) {
          state.admincart[index].quantity--;
          console.log("delete one by one", state.admincart[index].quantity);
          await saveUserCart(productId, state.admincart[index]);
        } else {
          console.log("delete completetly", state.admincart[index].quantity--);
          await deleteUserCart(productId);
          state.admincart.splice(index, 1);
        }
      } else {
        let index = state.cart.indexOf(item);
        let productId = state.cart[index].id
          ? state.cart[index].id
          : state.cart[index].product_id;
        console.log("productId", productId);
        if (state.cart[index].quantity > 1) {
          state.cart[index].quantity--;
          console.log("updateUserCart");
          await saveUserCart(productId, state.cart[index]);
        } else {
          console.log("deleteUserCart");
          await deleteUserCart(productId);
          state.cart.splice(index, 1);
        }
      }
      state.menuGroupItem = [];
      window.localStorage.setItem(
        "menuGroupItem",
        JSON.stringify(state.menuGroupItem)
      );
      this.commit("saveData", { item: item });
    } catch (error) {
      this.setlogError(
        "delete/update_user_cart",
        "Obtained error message in removeFromCart()",
        error.stack,
        this.$options.name
      );
    }
  }, // Decreasing the quantity of a cart item by 1
  // If there's only 1 item left, delete the whole entry
  async removeOneFromCart(state, payload) {
    try {
      console.log("payloadRemoveOneFromCart", payload);
      let productInCart = getProductInCartToRemove(payload, state);
      if (!productInCart) {
        return;
      }

      if (productInCart.quantity > 1) {
        productInCart.quantity--;
        payload.update &&
          (await updateUserCart(productInCart.id, productInCart));
      } else {
        let productIndex = isAdminCart(payload)
          ? state.admincart.indexOf(productInCart)
          : state.cart.indexOf(productInCart);

        payload.update && (await deleteUserCart(productInCart.id));

        if (isAdminCart(payload)) {
          state.admincart.splice(productIndex, 1);
        } else {
          state.cart.splice(productIndex, 1);
        }
      }
      this.commit("saveData", payload);
    } catch (error) {
      this.setlogError(
        "delete/update_user_cart",
        "Obtained error message in removeOneFromCart()",
        error.stack,
        this.$options.name
      );
    }
  },
  updateNotesInCart(state, item) {
    let productInCart = null;
    productInCart = isAdminCart(item)
      ? state.cart.find(product => product.order === item.order)
      : state.cart.find(product => product.order === item.order);

    if (!productInCart) {
      return;
    }

    productInCart.notes = item.notes;
    this.commit("saveData", { item: item });
  },
  saveData(state, payload) {
    if (
      (payload && payload.item && isAdminCart(payload.item)) ||
      (payload && isAdminCart(payload))
    ) {
      window.localStorage.setItem("admincart", JSON.stringify(state.admincart));
    } else {
      window.localStorage.setItem("cart", JSON.stringify(state.cart));
    }
    this.commit("updateStripeCheckoutItems");
  },
  setLoading(state, val) {
    state.loading = val;
  },
  toggleItemListModal(state, cubataItem = null) {
    state.cubataItem = cubataItem;
  },
  setQrExpiryTime(state, payload) {
    state.qrExpiryTime = payload;
  }
};

const actions = {};

const getters = {
  getCartTotalQuantity: state => products => {
    return state.cart.reduce((total, cartItem) => {
      if (cartItem.product_type_id === state.productTypeIds.drinks) {
        let product = products.drinks.find(d => d.id === cartItem.product_id);
        if (product && product.stock < 1) {
          return total;
        }
      }
      if (cartItem.product_type_id === state.productTypeIds.food) {
        let product = products.food.find(d => d.id === cartItem.product_id);
        if (product && product.stock < 1) {
          return total;
        }
      }
      if (cartItem.product_type_id === state.productTypeIds.dessert) {
        let product = products.dessert.find(d => d.id === cartItem.product_id);
        if (product && product.stock < 1) {
          return total;
        }
      }
      return total + cartItem.quantity;
    }, 0);
  },
  getQrExpiryTime: state => state.qrExpiryTime,
  language: state => state.language
};

// Helpers
function isAdminCart(item) {
  return item.cart_type !== undefined && item.cart_type === "admin";
}

function isMenuGroupItem(menuGroupItem) {
  return menuGroupItem === "menu_group_item";
}

function getProductFromCart(menuGroupItem, state, payload) {
  let cart = isAdminCart(payload.item) ? state.admincart : state.cart;
  if (isMenuGroupItem(menuGroupItem)) {
    return cart.find(item => {
      if (
        JSON.stringify(payload.item.starters) ===
          JSON.stringify(item.starters) &&
        JSON.stringify(payload.item.maincourse) ===
          JSON.stringify(item.maincourse) &&
        JSON.stringify(payload.item.desserts) ===
          JSON.stringify(item.desserts) &&
        JSON.stringify(payload.item.drinks) === JSON.stringify(item.drinks)
      ) {
        return item;
      }
    });
  }

  return cart.find(product => product.order === payload.item.order);
}

function getProductInCartToRemove(payload, state) {
  if (
    // eslint-disable-next-line no-constant-condition
    (payload.size && payload.size === "cubata") ||
    (payload.product && payload.product.hasCookingPoints) ||
    (payload.product &&
      ((payload.product.price_cubata &&
        false &&
        payload.product.price_cup &&
        false &&
        payload.product.price_shot &&
        false) ||
        payload.product.hasMainIngredient === true))
  ) {
    return getProductInCartByOrderActual(payload, state);
  } else {
    return getProductInCartByOrder(payload, state);
  }
}

function getProductInCartByOrder(payload, state) {
  if (isAdminCart(payload)) {
    return state.admincart.find(product => product.order === payload.order);
  } else {
    return state.cart.find(product => product.order === payload.order);
  }
}

function getProductInCartByOrderActual(payload, state) {
  if (isAdminCart(payload)) {
    return state.admincart.find(
      product => product.orderActual === payload.item
    );
  } else {
    return state.cart.find(product => product.orderActual === payload.order);
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: false
};
